"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UiTextField = void 0;
const callable_1 = require("client/components/ui/callable");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const React = require("react");
require("./text-field.less");
let UiTextField = class UiTextField extends react_1.Component {
    constructor() {
        super(...arguments);
        this.handleOnChange = (event) => {
            const { value } = event.target;
            callable_1.callable(this.props.onChange)(event, value);
        };
        this.handleFocus = () => {
            this.focused = true;
            this.props.onFocus && this.props.onFocus();
        };
        this.handleBlur = () => {
            this.focused = false;
            this.props.onBlur && this.props.onBlur();
        };
    }
    render() {
        const { className = "", error, id, leftItem, label, maxLength = 100, noBorder = false, required = false, rightItem } = this.props;
        const floatLabel = this.focused || this.props.value;
        const hasIcon = leftItem ? "has-icon" : "";
        const floatLabelClass = floatLabel ? "has-value" : "";
        const hasError = error ? "ui-text-field--error" : "";
        const noBorderClass = noBorder ? "no-border" : "";
        return (React.createElement("div", { className: `ui-text-field ${className} ${hasIcon} ${floatLabelClass} ${hasError}` },
            leftItem && React.createElement("div", { className: "ui-text-field__icon" }, leftItem),
            React.createElement("div", { className: "ui-text-field__input-block" },
                React.createElement("label", { className: floatLabelClass }, label),
                React.createElement("input", { autoFocus: this.props.autoFocus, id: id, type: this.props.type || "text", value: this.props.value || "", onChange: this.handleOnChange, onFocus: this.handleFocus, onBlur: this.handleBlur, required: required, maxLength: maxLength, className: noBorderClass })),
            rightItem ? (React.createElement("div", { className: "ui-text-field__right-item" }, rightItem)) : null));
    }
};
__decorate([
    mobx_1.observable
], UiTextField.prototype, "focused", void 0);
UiTextField = __decorate([
    mobx_react_1.observer
], UiTextField);
exports.UiTextField = UiTextField;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/ui/text-field/text-field.tsx
// module id = 2191
// module chunks = 0 1 2